export const routeLoadingClassName = 'route-loading';

export const routeLoadingOneIfLoadingElseZeroVar = '--route-loading-one';
export const routeLoadingDisplayNoneUnlessLoadingVar =
  '--route-loading-display';
